import { ref as t } from "vue";
const e = t({
  isOpen: !1,
  title: "",
  resolve: () => {
  },
  reject: () => {
  }
});
function f() {
  const o = (n) => new Promise((r, s) => {
    e.value = {
      ...n,
      isOpen: !0,
      resolve: r,
      reject: s
    };
  }), l = () => {
    e.value.isOpen = !1;
  };
  return {
    state: e,
    confirm: o,
    handleConfirm: (n) => {
      e.value.resolve(n), l();
    },
    handleCancel: () => {
      e.value.resolve(!1), l();
    }
  };
}
export {
  f as useConfirm
};
